import React, { useEffect } from 'react';

import { Header } from '@eika/header';
import { HeaderAttentionMessageProps } from '@eika/header/src/HeaderAttentionMessage';

import scriptLoaderEnhanced from '../../../core/scriptLoaderEnhanced';
import { menuConfigMapper, nativeMenuConfigMapper, logoConfigMapper, linkMapper, linkAppHeader } from './configMapper';
import { useConfig } from './default-config';

const HeaderView = (): JSX.Element => {
    const {
        MenuItems,
        NativeMenuItems,
        IsNative,
        Frontpage,
        Logo,
        LogoutUrl,
        LogoutButtonText,
        ShowAttentionMessage,
        AttentionMessage,
        BankLink,
        HeaderApp,
    } = useConfig();

    const headerAttentionMessageProps: HeaderAttentionMessageProps = {
        id: AttentionMessage?.Id,
        message: AttentionMessage?.Message ?? '',
        type: AttentionMessage?.Type,
        isNative: AttentionMessage?.IsNative,
        link:
            AttentionMessage?.Link?.Anchor && AttentionMessage?.Link?.Text
                ? {
                      anchor: AttentionMessage.Link.Anchor,
                      text: AttentionMessage.Link.Text,
                  }
                : undefined,
    };
    useEffect(() => {
        scriptLoaderEnhanced(window.document);
        if (HeaderApp?.Namespace) {
            window.dispatchEvent(
                new CustomEvent('engine:rerender', { detail: { namespace: HeaderApp?.Namespace } } as Record<
                    string,
                    unknown
                >),
            );
        }
    }, [HeaderApp]);

    return (
        <Header
            alwaysMenu
            frontpage={Frontpage}
            menuItems={menuConfigMapper(MenuItems ?? [])}
            nativeMenuItems={nativeMenuConfigMapper(NativeMenuItems ?? [])}
            isNative={IsNative}
            logo={logoConfigMapper(Logo!)}
            logoutUrl={LogoutUrl}
            logoutButtonText={LogoutButtonText}
            attentionMessage={headerAttentionMessageProps}
            showAttentionMessage={ShowAttentionMessage}
            bankLink={linkMapper(BankLink)}
            headerApp={linkAppHeader(HeaderApp!)}
        />
    );
};

export default HeaderView;
